import { Modal } from "@aidkitorg/component-library";
import AuthPage from "../Auth";

export function AuthPageModal(props: {
  open: boolean;
  onClose: () => void;
  onLoginSuccess: () => void;
}) {
  const L = {
    login: {
      modal_title: "Login, Authenticate, etc"
    }
  }

  return <Modal open={props.open} onClose={props.onClose} title={L.login.modal_title}>
    <AuthPage onLoginSuccess={props.onLoginSuccess} />
  </Modal>
}
